/* bag-chat-dock.js - Trust fixes, 29 Sep 2026. Where the Shopify Inbox launcher sits on a
   phone, on the product page.

   At 390x664 the first screen now holds the photo, the title, the price and the whole Add
   to cart button, and the launcher's own place (bottom right, 20px up) is on that button.
   The Inbox app embed only has a vertical setting, which would move it on every page and
   on desktop too, so the move is made here instead, at phone widths only:
   1. the photo on screen: the launcher sits on the photo's lower right corner and moves
      with it (class bag-chat-docked, offset --bag-chat-dock);
   2. the photo scrolled away and the buy box on screen: it steps aside, hidden and out of
      reach (class bag-chat-away), so it never covers the title, the price or the button;
   3. the sticky Add to cart bar showing, or the buy box scrolled past: neither class, so
      bag-store.js's DRO-97 lift puts it 12px above the bar exactly as before.
   At 750px and up nothing here changes anything. The launcher's natural place is read from
   the button's container, which the transform does not move, so a reading taken during
   the Inbox entrance animation is still exact. Styles: assets/bag-first-screen.css. */
(function () {
  'use strict';
  if (window.__bagChatDock) return;
  window.__bagChatDock = true;

  var PHONE = window.matchMedia('(max-width: 749px)');
  var state = '';
  var dock = null;

  function parts() {
    var host = document.querySelector('shopify-chat');
    if (!host || !host.shadowRoot) return null;
    var act = host.shadowRoot.querySelector('[part~=activator]');
    return act ? { host: host, act: act } : null;
  }

  /* Every write is guarded by a read. A change of state is applied with transitions off and
     the style flushed, so the launcher jumps to its new place instead of sliding there. */
  function set(p, next, offset) {
    var changing = next !== state;
    if (changing) p.host.classList.add('bag-chat-instant');
    if (offset !== null && offset !== dock) {
      p.host.style.setProperty('--bag-chat-dock', offset + 'px');
      dock = offset;
    }
    if (changing) {
      p.host.classList.toggle('bag-chat-docked', next === 'docked');
      p.host.classList.toggle('bag-chat-away', next === 'away');
      state = next;
      void window.getComputedStyle(p.act).transform;
      p.host.classList.remove('bag-chat-instant');
    }
  }

  function onScreen(r) {
    return r.height > 0 && r.bottom > 0 && r.top < window.innerHeight;
  }

  function place() {
    var p = parts();
    if (!p) return;
    var gallery = document.querySelector('main[data-template^=product] media-gallery');
    var bar = document.querySelector('.bag-sticky.is-visible');
    var home = p.act.parentElement;
    if (!PHONE.matches || !gallery || !home || bar) { set(p, '', null); return; }
    var tall = p.act.offsetHeight;
    if (!tall) return;
    var nat = home.getBoundingClientRect();
    var g = gallery.getBoundingClientRect();
    var header = document.querySelector('#header-component, header-component, .header');
    var top = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
    var bottom = Math.round(g.bottom - 14);            /* inside the photo's colour mat */
    if (bottom - tall >= top + 8) {
      /* Never lower than Shopify's own place: on a short screen the photo runs past it. */
      set(p, 'docked', Math.min(0, bottom - Math.round(nat.bottom)));
      return;
    }
    var details = document.querySelector('main[data-template^=product] .product-details');
    set(p, details && onScreen(details.getBoundingClientRect()) ? 'away' : '', null);
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () { queued = false; place(); });
  }

  /* The sticky bar toggles .is-visible from bag-store.js; follow it before the next paint. */
  function watchBar() {
    if (!window.MutationObserver) return;
    var bars = document.querySelectorAll('.bag-sticky');
    if (!bars.length) return;
    var mo = new MutationObserver(place);
    Array.prototype.forEach.call(bars, function (b) {
      mo.observe(b, { attributes: true, attributeFilter: ['class'] });
    });
  }

  /* The Inbox bundle renders its button late; place it before that render is painted. */
  function watchChat(tries) {
    var host = document.querySelector('shopify-chat');
    if (host && host.shadowRoot && window.MutationObserver) {
      new MutationObserver(place).observe(host.shadowRoot, { childList: true, subtree: true });
      place();
      return;
    }
    if (tries < 60) window.setTimeout(function () { watchChat(tries + 1); }, 250);
  }

  function boot() {
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    document.addEventListener('change', schedule);
    if (PHONE.addEventListener) PHONE.addEventListener('change', schedule);
    else if (PHONE.addListener) PHONE.addListener(schedule);
    watchBar();
    watchChat(0);
    place();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
